import { LightSparkles } from 'components/Sparkles/LightSparkles';
import { GraniteButton } from 'components/V2/Button/GraniteButton';
import { Glow } from './RectangleFaces';
import MagicBox from './MagicBox';
import { useNavigate } from 'react-router-dom';

const EmptyActiveOrder = () => {
  const navigate = useNavigate();

  const onOrderService = () =>
    navigate('/access-express/v3/order-services/access');

  return (
    <div className="group relative w-full min-w-[364px] overflow-hidden rounded bg-background-base-surface-2 p-6 shadow-elevation3 transition-all duration-500 ease-in-out hover:bg-background-inventory-empty-box-hover">
      <div className="absolute inset-0 flex items-center justify-center">
        <Glow className="h-full w-full" />
      </div>
      <div className="relative z-10 flex h-full flex-col justify-between gap-9">
        <div className="space-y-1">
          <p className="text-xl font-bold text-content-base-default">
            Ready to order services?
          </p>
          <p className="text-xs text-content-base-subdued">
            Start exploring Granite’s latest products & services.
          </p>
        </div>
        <MagicBox />
        <div>
          <GraniteButton
            variant="tertiary"
            className="w-full"
            onClick={onOrderService}
          >
            Get started
            <LightSparkles fill="currentColor" />
          </GraniteButton>
        </div>
      </div>
    </div>
  );
};

export default EmptyActiveOrder;
